var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMainColorAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 32,
    viewBox: "0 0 243 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10812_10610)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1338 1.68568C47.2533 1.33609 47.5825 0.800049 48.4827 0.800049H48.5643H59.422C60.5582 0.840835 60.7359 1.75852 60.7592 1.94205C60.1562 18.1777 46.7872 31.2001 30.3796 31.2001C13.9721 31.2001 0.562262 18.1369 0 1.86339C0.0670053 1.55167 0.33794 0.823355 1.39254 0.823355C1.50034 0.823355 1.58773 0.814615 1.65765 0.800049H12.0289C12.093 0.808789 12.1687 0.814615 12.2591 0.814615C13.2496 0.814615 13.5496 1.46428 13.637 1.7993C14.1556 10.5857 21.43 17.5747 30.3825 17.5747C39.335 17.5747 46.6706 10.5246 47.1338 1.68568Z",
    fill: "url(#paint0_linear_10812_10610)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4609 8.2832H76.9324V29.6361H83.1894V8.2832H91.6608V2.25708H68.4609V8.2832Z",
    fill: "#040000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.859 2.25708H94.6017V29.6361H100.859V2.25708Z",
    fill: "#040000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.062 18.7618H148.779V12.8205H137.062V8.2832H149.755V2.25708H130.805V29.6361H149.953V23.6147H137.062V18.7618Z",
    fill: "#040000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.432 2.25708H160.831V29.6361H167.088V21.0328H171.432C176.832 21.0328 181.016 16.8489 181.016 11.6473C181.016 6.44568 176.832 2.25708 171.432 2.25708ZM173.284 14.5213C172.436 15.0538 171.07 15.148 170.41 15.1621H167.088V8.12301H170.749C171.451 8.1607 172.516 8.29262 173.237 8.72609C174.151 9.34802 174.759 10.4081 174.759 11.6473C174.759 12.8864 174.175 13.8994 173.289 14.5261",
    fill: "#040000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.996 2.25708H183.739V29.6361H189.996V2.25708Z",
    fill: "#040000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M206.535 8.76416C208.622 8.76416 210.619 9.65465 212.019 11.2095L216.806 6.9125C214.191 4.00074 210.45 2.32812 206.535 2.32812C198.925 2.32812 192.739 8.51915 192.739 16.1237C192.739 23.7282 198.93 29.9239 206.535 29.9239C210.412 29.9239 214.134 28.2795 216.745 25.4055L211.986 21.0802C210.591 22.6115 208.608 23.4926 206.535 23.4926C202.473 23.4926 199.17 20.1898 199.17 16.1284C199.17 12.067 202.473 8.76416 206.535 8.76416Z",
    fill: "#040000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M232.782 14.8417L242.092 2.25708H234.666L226.925 12.7262C226.435 12.6555 225.733 12.599 225.229 12.5707V2.26179H218.972V29.6408H225.229V19.0869C226.473 19.134 227.646 19.2989 228.715 19.8737C232.202 21.7442 234.572 25.3815 234.577 29.6314H241.027C241.027 23.2849 237.814 17.7959 232.791 14.8464",
    fill: "#040000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.129 11.6894C127.129 6.48784 122.945 2.30396 117.546 2.30396H105.512V29.683H111.769V21.0796V20.8252C114.474 20.8865 116.872 21.0137 118.653 22.7994C120.599 24.7452 121.226 27.0586 121.466 29.6877H127.402C127.402 25.8148 125.466 21.3199 123.049 19.1337C125.607 17.5742 127.125 14.7378 127.125 11.6989M119.322 14.5824C118.507 15.0912 117.221 15.1996 116.542 15.2184H111.765V8.17931H116.754C117.395 8.21229 118.366 8.32065 119.091 8.67402H119.101C119.167 8.71172 119.228 8.7447 119.289 8.78239C120.227 9.40432 120.868 10.4597 120.868 11.6942C120.868 12.9286 120.246 13.951 119.327 14.5776",
    fill: "#040000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10812_10610",
    x1: 0.642901,
    y1: 15.4965,
    x2: 61.4021,
    y2: 15.4965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#32B9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5977F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#714EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#7B3FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D413E5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10812_10610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.7592,
    height: 30.4,
    fill: "white",
    transform: "translate(0 0.800049)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMainColorAll);
export default __webpack_public_path__ + "static/media/Logo-mainColor-all.c54201846e4a17c2408caaef49838b59.svg";
export { ForwardRef as ReactComponent };